import styled from 'styled-components';
import {
  Menu as MenuComponent,
  ListItemColumn,
  SVGIcon,
} from '@pearsontechnology/aero-components';

const KnowledgeMapIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
`;

export const MenuListItemText = styled.div`
  margin: 0 4px;
`;

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
  width: 120px;
`;

export const ListItemUtilityColumn = styled(ListItemColumn)`
  flex: 0 0 37px;  
  @media (max-width: 700px){
    flex: 0 0 37px;
  }
`;

export const StyledIcon = styled(SVGIcon)`
  height:30px;
  width:29px;
`;

export {
  KnowledgeMapIcon,
};
